<template>
  <v-row>
    <v-col>
      <v-row justify="center" no-gutters>
        <v-col class="ma-8" lg="5">
          <p class="body-1">{{ $t("contact.info") }}</p>

          <a class="title" href="http://www.simrishamn.se/mtos"
            >www.simrishamn.se/mtos</a
          >
          <br />
          <br />
          <a
            class="title"
            href="https://www.facebook.com/More-Than-One-Story-233688136703015/"
          >
            www.facebook.com/More-Than-One-Story
          </a>
          <br /><br />
          <a class="title" href="mailto:morethanonestory@simrishamn.se"
            >morethanonestory@simrishamn.se</a
          >
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "howtoplay",
  components: {}
};
</script>
